export default function ThankYou() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-indigo-100 p-6">
      <div className="bg-white p-10 rounded-3xl shadow-2xl max-w-xl text-center">
        <h1 className="text-4xl font-bold text-blue-800 mb-6">🎉 Thank You for Registering!</h1>
        <p className="text-lg text-gray-700 mb-4 leading-relaxed">
          📌 Bookmark this Zoom link for the session:
        </p>
        <a
          href="https://us06web.zoom.us/j/82296051123?pwd=4tEMMHtSawXBWJEppsAXDk6I2DwkTC.1"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 font-medium underline text-lg break-all"
        >
          https://us06web.zoom.us/j/82296051123?pwd=4tEMMHtSawXBWJEppsAXDk6I2DwkTC.1
        </a>
        <p className="mt-6 text-md text-gray-700">
          🗓 <strong>Date:</strong> 21st July <br />
          ⏰ <strong>Time:</strong> 7:00 AM IST <br />
          📲 A reminder will be sent to your registered email and mobile.
        </p>
      </div>
</div>
);
}
